var relationships = {
  relationships: {
    spouse: {
      txt_id: "spouse",
      name: "Spouse"
    },
    friend: {
      txt_id: "friend",
      name: "Friend"
    },
    family: {
      txt_id: "family",
      name: "Family"
    },
    partner: {
      txt_id: "partner",
      name: "Partner"
    },
    other: {
      txt_id: "other",
      name: "Other"
    }
  }
};

module.exports = relationships;
